import { Bot, Map, Users, UserRoundCheck, Workflow } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";
import { DashboardShot } from "@/components/aziende/DashboardShot";
import { FeatureCard } from "@/components/aziende/FeatureCard";

const CARDS = [
  { id: "junior", Icon: Users, title: "Pool Junior", text: "Neodiplomati che hanno completato il test attitudinale Prodigy. Profili anonimi con grafico radar a 6 dimensioni e analisi AI. Il contatto parte solo se lo studente accetta." },
  { id: "senior", Icon: UserRoundCheck, title: "Pool Senior", text: "Professionisti con CV completo, test attitudinale e Analisi AI. Sblocchi il contatto con i crediti inclusi nel pacchetto." },
  { id: "argos", Icon: Bot, title: "Argos, l'AI Recruiter", text: "Chiedi in linguaggio naturale «chi è il profilo più adatto per…» e ottieni una shortlist motivata, aperta direttamente sulle schede." },
  { id: "atlas", Icon: Map, title: "Corporate Atlas", badge: "Omega", text: "Mappa i reparti, dichiara dove stai assumendo e ricevi match proattivi appena entra un profilo coerente." },
  { id: "automated", Icon: Workflow, title: "Automated Solutions", badge: "Omega", text: "Costruisci il «Radar Ideale» del ruolo, ottieni il Fit Score di ogni candidato, salva pipeline dinamiche e ricevi gli Argos Alerts quando compare un nuovo match." },
];

export const HubOperativo = () => (
  <section className="relative px-6 py-20 lg:py-36" data-testid="hub-operativo-section">
    <div className="max-w-7xl mx-auto">
      <Reveal className="mb-12 lg:mb-16" data-testid="hub-row-dashboard">
        <Eyebrow className="mb-6">Recruiting</Eyebrow>
        <h2 className="font-extrabold tracking-[-0.04em] leading-[1] text-4xl sm:text-5xl lg:text-6xl">Trova le persone giuste</h2>
        <p className="mt-6 max-w-2xl text-base sm:text-lg text-titanium leading-relaxed">
          Una dashboard semplice e chiara: profili pronti, analisi attitudinale e AI in un solo colpo d'occhio, per scegliere più in fretta e con più certezza.
        </p>
      </Reveal>
      <Reveal delay={150} className="mx-auto max-w-[1200px]">
        <DashboardShot />
      </Reveal>
      <div className="mt-16 lg:mt-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
        {CARDS.map((c, i) => (
          <Reveal key={c.id} delay={(i % 3) * 110} className="h-full">
            <FeatureCard {...c} testId={`recruit-card-${c.id}`} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
